module.exports = __webpack_public_path__ + "static/media/nav-icon-career-conversation-active.295ede13.svg";